import React, { useState, useEffect } from "react";
import { Row, Col, Image, Divider, Flex, Skeleton, Button } from "antd";
import { useOutletContext, useLocation } from "react-router-dom";
import useActions from "./hooks/useActions";
import defaultImage from "../../../../../../../../assets/images/png/general/img_thumb_default.png";
import ic_addcollection_contentlibrary from "../../../../../../../../assets/images/svgs/ic_addcollection_contentlibrary.svg";
import ic_removecollection_contentlibrary from "../../../../../../../../assets/images/svgs/ic_removecollection_contentlibrary.svg";

import ModalConfirm from "../../../../../../../../components/ModalConfirm";

// for translate
import { useTranslation } from "react-i18next";

// import styles
import styles from "./styles";

import CourseDescriptionContentLibraryMobile from "./indexMobile";
import ModalDetailCourseMobile from "./modal/ModalDetailCourseMobile";

const CourseCL = ({ isMobileVersion }) => {
  const { t, i18n } = useTranslation();
  const [outletProps] = useOutletContext();
  const [courseDesc, setCourseDesc] = useState("");
  const [isCollection, setIsCollection] = useState(false);
  const [isCollectionLoading, setIsCollectionLoading] = useState(false);
  const [modalRemove, setModalRemove] = useState(false);
  const [isOpenModalDetailCourse, _setOpenModalDetailCourse] = useState(false);

  const setOpenModalDetailCourse = () => {
    _setOpenModalDetailCourse(!isOpenModalDetailCourse);
  };

  const {
    journeyId,
    courseId,
    loadingLP,
    loadingLM,
    setListModule,
    setListModuleSupport,
    setLoadingLM,
    mainState,
    reFetchLeftSection,
    setRefetchLeftSection,
    setPercentCompleteCourse,
  } = outletProps;

  const {
    currCourse,
    addCourseToCollection,
    loadingAdd,
    setLoadingAdd,
    statusAdd,
    deleteCollection,
    loadingDelete,
    setLoadingDelete,
    statusDelete,
  } = useActions(
    loadingLP,
    journeyId,
    courseId,
    setListModule,
    setListModuleSupport,
    setLoadingLM,
    mainState,
    reFetchLeftSection,
    setRefetchLeftSection,
    setPercentCompleteCourse,
  );

  const location = useLocation();
  const locPathname = location.pathname;
  const arrPath = locPathname.split("/");
  const idCoursePath = arrPath[arrPath.length - 1];
  const idJourneyPath = arrPath[arrPath.length - 3];
  const academyId = arrPath[arrPath.length - 5];

  const convertEnter = (desc) => {
    const replacer = desc.replace(/(?:\r\n|\r|\n)/g, "\n");

    setCourseDesc(replacer);
  };

  const funcCollection = (flag) => {
    if (flag === "add") {
      addCourseToCollection(parseInt(idCoursePath), "course");
      setIsCollection(!isCollection);
    }
    if (flag === "remove") setModalRemove(true);
  };

  const handleRemove = () => {
    setIsCollectionLoading(true);
    setModalRemove(false);
    setTimeout(() => {
      setIsCollection(!isCollection);
      setIsCollectionLoading(false);
    }, 500);
    deleteCollection(parseInt(idCoursePath), "course");
  };

  useEffect(() => {
    if (currCourse.description !== undefined && currCourse.description !== null)
      convertEnter(currCourse.description);
    if (currCourse.is_collection === 1) {
      setIsCollection(true);
    } else {
      setIsCollection(false);
    }
  }, [currCourse]);

  useEffect(() => {
    if (loadingAdd === false) {
      const successAdd = `${t(
        "feature.feature_cl.collection_action.course_snack",
      )} “${currCourse.name}” ${t(
        "feature.feature_cl.collection_action.has_been_added",
      )}`;
      const failedAdd = `Error Added status = ` + statusAdd;
      mainState.setMessageSnack(statusAdd === 200 ? successAdd : failedAdd);
      mainState.setOpenedSnack(true);

      setLoadingAdd(true);
    }
  }, [loadingAdd]);

  useEffect(() => {
    if (loadingDelete === false) {
      const successDelete = `${t(
        "feature.feature_cl.collection_action.course_snack",
      )} “${currCourse.name}” ${t(
        "feature.feature_cl.collection_action.has_been_remove",
      )}`;
      const failedDelete = `Error Added status = ` + statusDelete;
      mainState.setMessageSnack(
        statusDelete === 200 ? successDelete : failedDelete,
      );
      mainState.setOpenedSnack(true);

      setLoadingDelete(true);
    }
  }, [loadingDelete]);

  const propsCourse = {
    ...currCourse,
    courseDesc,
  };

  return (
    <>
      {isMobileVersion ? (
        <CourseDescriptionContentLibraryMobile
          loading={loadingLM}
          wraperStyle={styles.wrapperStyleMobile}
          rowImageStyle={styles.rowImageStyleMobile}
          index={currCourse.sort}
          // thumbnail={
          //   <Image
          //     width={"100%"}
          //     height={160}
          //     style={styles.imageThumbnailMobile}
          //     src={currCourse.thumbnail}
          //     preview={false}
          //     fallback={defaultImage}
          //     alt="Course Thumbnail Content Library Mobile"
          //   />
          // }
          thumbnail={currCourse.thumbnail}
          divRightStyle={styles.divRightStyleMobile}
          pProgramStyle={styles.pProgramStyleMobile}
          titleCourseDescStyle={styles.titleCourseDescStyleMobile}
          courseName={currCourse.name}
          rowBottomFirstStyle={null}
          rowBottomSecondStyle={styles.rowBottomSecondStyleMobile}
          pointImageWidth={16}
          totalPoint={null}
          totalCourses={null}
          dividerStyle={styles.dividerStyle}
          description={courseDesc}
          overDue={null}
          flagBtnCollection={true}
          funcCollection={funcCollection}
          isCollection={isCollection}
          setOpenModalDetailCourse={setOpenModalDetailCourse}
          isMobileVersion={isMobileVersion}
          mainState={mainState}
          location={location}
          isCollectionLoading={isCollectionLoading}
        />
      ) : (
        <div style={styles.courseWrapper}>
          <Flex vertical>
            <Flex style={{ position: "relative" }}>
              <div className="w-100" style={styles.courseNameWrapper}>
                <div style={styles.textCourse}>
                  {loadingLM ? (
                    <Skeleton.Input
                      active
                      size={12}
                      style={styles.textCourseSkeleton}
                    />
                  ) : (
                    <>{t("feature.feature_cl.course_desc.course_cap")}</>
                  )}
                </div>
                <div style={styles.courseName}>
                  {loadingLM ? (
                    <Skeleton.Input
                      active
                      size={22}
                      style={styles.courseNameSkeleton}
                    />
                  ) : (
                    currCourse.name
                  )}
                </div>
                <Divider style={styles.divider} />
              </div>
              <div style={styles.divStyle}>
                <div
                  className="btn-collection"
                  style={{ position: "absolute", right: 0 }}
                >
                  {loadingLM ? (
                    <Skeleton.Button
                      active
                      style={{
                        width: "177px",
                        height: "32px",
                        borderRadius: "6px",
                      }}
                    />
                  ) : (
                    <Button
                      className={
                        isCollection
                          ? "btn-remove-collection-content-library"
                          : "btn-add-collection-content-library"
                      }
                      name={
                        isCollection
                          ? "btn-remove-course-collection-content-library"
                          : "btn-add-course-collection-content-library"
                      }
                      style={{
                        borderRadius: "6px",
                        padding: "6px 12px",
                        fontSize: "12px",
                        fontWeight: "500",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginRight: "auto",
                        marginLeft: "0",
                        width: "177px",
                        gap: "4px",
                      }}
                      onClick={() =>
                        funcCollection(isCollection ? "remove" : "add")
                      }
                      loading={isCollectionLoading}
                    >
                      <div
                        style={
                          isMobileVersion
                            ? { marginTop: "-3px", marginRight: "4px" }
                            : {
                                marginRight: 0,
                              }
                        }
                      >
                        <Image
                          preview={false}
                          src={
                            isCollection
                              ? ic_removecollection_contentlibrary
                              : ic_addcollection_contentlibrary
                          }
                        />
                      </div>
                      <span style={{ lineHeight: "normal" }}>
                        {isCollection
                          ? t(
                              "feature.feature_cl.main_collection_card.remove_from_collection",
                            )
                          : t(
                              "feature.feature_cl.collection_action.add_to_collection",
                            )}
                      </span>
                    </Button>
                  )}
                </div>
              </div>
            </Flex>
          </Flex>
          <Flex>
            <div className="w-100" style={styles.courseDesc}>
              {loadingLM ? (
                <Skeleton paragraph={{ rows: 10 }} active />
              ) : (
                courseDesc
              )}
            </div>
            <div>
              {loadingLM ? (
                <Skeleton.Avatar
                  active
                  shape="square"
                  style={styles.courseImageSkeleton}
                />
              ) : (
                <Image
                  width={209}
                  height={143}
                  style={styles.courseImage}
                  src={currCourse.thumbnail}
                  preview={false}
                  fallback={defaultImage}
                  alt="Course Thumbnail"
                />
              )}
            </div>
          </Flex>
        </div>
      )}

      <ModalDetailCourseMobile
        isOpen={isOpenModalDetailCourse}
        onClose={setOpenModalDetailCourse}
        data={propsCourse}
      />

      <ModalConfirm
        isOpen={modalRemove}
        setIsOpen={setModalRemove}
        handleModal={handleRemove}
        message={t(
          "feature.feature_cl.main_collection_card.remove_from_collection_ques",
        )}
      />
    </>
  );
};

export default CourseCL;
